export const calculateBmcEolDaysLeft = () => {
    const bmcEolDate = Date.UTC(2026, 6, 6, 23, 59, 59, 999);
    const today = new Date().setUTCHours(23, 59, 59, 999);
    const calculatedDifference = bmcEolDate - today;
    return Math.ceil(calculatedDifference / (1000 * 60 * 60 * 24));
};
